import MaterialIcon from "../material-icon/material-icon";
import styles from "./back-arrow-button.module.scss";

interface IProps {
  onBack: () => void;
  iconColor?: string;
  bgColor?: string;
}

const BackArrowButton = ({
  onBack,
  bgColor = "--white",
  iconColor = "--dark",
}: IProps) => {
  return (
    <button
      className={`${styles.backArrowBtn} mt-1`}
      onClick={onBack}
      style={{
        backgroundColor: `var(${bgColor})`,
      }}
      type="button"
      aria-label="Go back"
    >
      <MaterialIcon icon="chevron_left" color={`var(${iconColor})`} size={22} />
    </button>
  );
};

export default BackArrowButton;
